import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router';
import VueHeadful from 'vue-headful';
import VueCookies from 'vue-cookies'


import { globalFormatDate, globalRusDateShort, globalUtcDate, globalDateDots, globalDateHours } from '../public/utils.js';

Vue.use(VueCookies)

Vue.use(VueRouter)

Vue.component('vue-headful', VueHeadful);

Vue.config.productionTip = false

const routes = [
  { path: '*', component: App }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

Vue.mixin({
  data: function () {
    return {
      //nodePort: 4000,
      nbsp: '&nbsp;',
      site_title: 'RPG Planet Board (в прошлом Realms.ru)',
      publicPath: process.env.BASE_URL,
    }
  },
  methods: {
    getNodePath() {
      //console.log(this.$router.history.current.fullPath); // will output /index.php?act=Members
      //console.log(window.location.protocol + "//" + window.location.hostnamer + "/api/");
      return window.location.protocol + "//" + window.location.hostname + ":" + window.location.port + "/api/"
      //return window.location.protocol + "//" + window.location.hostname + ":" + this.nodePort + "/"
    },
    htmlDecode(input) {
      let doc = new DOMParser().parseFromString(input, "text/html");
      return doc.documentElement.textContent;
    },
    spanSeconds(dateEarly, dateLater) {
      let delta = Math.abs(dateLater - dateEarly) / 1000;
      return delta;
    },
    fixAvatarPath(path) {
      if (!path || path.length == 0 || path.startsWith("http://"))
        return path;
      return this.publicPath + 'avatars/' + path;
    },
    getTitleFromPosts(posts) {
      if (posts >= 15000)
        return "Titan";
      else if (posts >= 7500) {
        return "Expanded Member III";
      } else if (posts >= 3000) {
        return "Expanded Member II";
      } else if (posts >= 1500) {
        return "Expanded Member";
      } else if (posts >= 750) {
        return "Extended Member";
      } else if (posts >= 300) {
        return "Advanced Member";
      } else if (posts >= 150) {
        return "Member";
      } else if (posts >= 50) {
        return "Newbie"
      }
      return "Nobody";
    },
    getPipsFromPosts(posts) {
      if (posts >= 15000)
        return 8;
      else if (posts >= 7500) {
        return 7;
      } else if (posts >= 3000) {
        return 6;
      } else if (posts >= 1500) {
        return 5;
      } else if (posts >= 750) {
        return 4;
      } else if (posts >= 300) {
        return 3;
      } else if (posts >= 150) {
        return 2;
      } else if (posts >= 50) {
        return 1
      }
      return 0;
    },
    fixSmileysPath(postText) {
      return postText.replace(/<#EMO_DIR#>\//g, "");
    },
    fixRpgplanetLinks(html) {
      // oldforums.rpgplanet.ru to /oldforums/, examples: http://localhost:8080/index.php?showtopic=221#2995
      // steelworld.rpgplanet.ru/forums/ to local url
      // etc,.. many such cases.
      // eg. http://localhost:8080/index.php?showtopic=3603 , http://localhost:8080/index.php?showtopic=192&st=268
      return html.replace(/<a href=("|')http:\/\/((www|forums)\.){0,2}((.{0,15}?)\.){0,1}?(rpgplanet|realms)\.ru(\/forums)?/gu, function(a, b, c, d, e, f) {
          let result = '';
          if (f) {
            result = `<a href=${b}/${f}`;
          } else {
            result = `<a href=${b}`;
          }
          return result;
        })
        // img src="http://www.rpgplanet.ru/forums" (and without forums) to local website url
        .replace(/<img src="http:\/\/www\.rpgplanet\.ru(\/forums){0,1}/g, function(a, b) {
          return a.replace("http://www.rpgplanet.ru/forums", "").replace("http://www.rpgplanet.ru", "");
        });
    },
    fixVariousTags(html) {
      // [mergetime=1232312] turns it into Добавлено: дата
      return html.replace(/\[mergetime=(\d+)\]/g, function(a, b) {
          return '<b>Добавлено: ' + globalFormatDate(b) + '</b>';
        })
        // changes [hide]text[/hide] to <i>text</i> - hide tag was used to hide info from unregistered users only
        .replace(/\[hide\](.*?)\[\/hide\]/gi, "<i>$1</i>")
        // change [topic=123]text[/topic] to <a href="index.php?showtopic=123">text</a>
        .replace(/\[topic=([0-9]+)\](.+?)\[\/topic\]/gi, "<a href=\"/index.php?showtopic=$1\">$2</a>")
        // same with [user]
        .replace(/\[user=([0-9]+)\](.+?)\[\/user\]/gi, "<a href=\"/index.php?showuser=$1\">$2</a>")
        // same with [forum]
        .replace(/\[forum=([0-9]+)\](.+?)\[\/forum\]/gi, "<a href=\"/index.php?showforum=$1\">$2</a>")
        // same with [post]
        .replace(/\[post=([0-9]+)\](.+?)\[\/post\]/gi, "<a href=\"/index.php?view=findpost&p=$1\">$2</a>")
        // [hl] tag gives text a different color
        .replace(/\[hl\](.+?)\[\/hl\]/gi, "<span class=\"thread__hl\">$1</span>");
    },
  },
  filters: {
    formatDate: function(value) {
      return globalFormatDate(value);
    },
    formatRusDateShort: function(value) {
      return globalRusDateShort(value);
    },
    formatInt: function(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "); // formats 4123 to 4 123
    },
    formatUtcDate: function(value) {
      return globalUtcDate(value);
    },
    formatDateDots: function(value) {
      return globalDateDots(value);
    },
    formatDateHours: function(value) {
      return globalDateHours(value);
    }
  }
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
